import {ExpirableApolloServiceProvider} from '@coolcolduk/ui-apollo-client';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import {MessageProvider} from '@coolcolduk/ui-mui';
import AppRouter from './AppRouter';
import {firebaseAuth, getFirebaseFunction} from './config/firebase';
import {theme} from './styles/theme';

export default function App() {
  return (
    <ExpirableApolloServiceProvider
      url={getFirebaseFunction('gql')}
      tokenFetcher={async () => firebaseAuth.currentUser?.getIdToken()}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MessageProvider>
          <AppRouter />
        </MessageProvider>
      </ThemeProvider>
    </ExpirableApolloServiceProvider>
  );
}
